import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { map, retry, tap } from 'rxjs/operators';
import { AuthHeaderService } from 'app/shared/auth-header.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  constructor(
    private http: HttpClient,
    private authHeaderService: AuthHeaderService,
  ) { }

  createPayroll = (requestBody) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.post(`${environment.API_URL2}/xas/v1/payroll`, requestBody, { headers }).pipe(retry(3));
  }

  updatePayroll = (requestBody: any, payrollId: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.put(`${environment.API_URL2}/xas/v1/payroll/${payrollId}`, requestBody, { headers }).pipe(retry(3));
  }

  addStaffToPayroll = (requestBody: any, payrollId: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.post(`${environment.API_URL2}/xas/v1/payroll/${payrollId}/items`, requestBody, { headers }).pipe(retry(3));
  }

  fetchPayrolls = (id: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/payroll/merchant/${id}`, { headers }).pipe(retry(3));
  }

  fetchPayroll = (merchantId: string, staffId: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/payroll/${merchantId}/${staffId}`, { headers }).pipe(retry(3));
  }

  deletePayroll = (merchantId: string, payrollId: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.delete(`${environment.API_URL2}/xas/v1/payroll/${merchantId}/${payrollId}`, { headers }).pipe(retry(3));
  }

}
